"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getSingleLetterRelativeTime = void 0;

var _moment = _interopRequireDefault(require("moment"));

/**
 * Formats a Moment into a relative time ago, that is narrowed to a single character.
 *
 * i.e.
 * 1s
 * 2m
 * 3h
 * 4d
 * 5m
 * 6y
 */
var getSingleLetterRelativeTime = function getSingleLetterRelativeTime(time) {
  var now = (0, _moment.default)();
  var yearDiff = now.diff(time, 'years');
  var monthDiff = now.diff(time, 'months');
  var dayDiff = now.diff(time, 'days');
  var hourDiff = now.diff(time, 'hours');
  var minuteDiff = now.diff(time, 'minutes');
  var secondDiff = now.diff(time, 'seconds');

  if (yearDiff >= 1) {
    return "".concat(yearDiff, "y");
  } else if (monthDiff >= 1) {
    return "".concat(monthDiff, "m");
  } else if (dayDiff >= 1) {
    return "".concat(dayDiff, "d");
  } else if (hourDiff >= 1) {
    return "".concat(hourDiff, "h");
  } else if (minuteDiff >= 1) {
    return "".concat(minuteDiff, "m");
  } else if (secondDiff >= 1) {
    return "".concat(secondDiff, "s");
  } else {
    return '';
  }
};

exports.getSingleLetterRelativeTime = getSingleLetterRelativeTime;